import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { isCurrentRegionUsingFlatTaxSelector } from '@/selectors'
import { isCartPath } from '@/utils/path'
import { translate } from '@/utils/translations'

import TaxListItem from './TaxListItem'

const TaxListItems = () => {
  const details = useSelector(state => state.taxes.details)
  const isUsingFlatTax = useSelector(isCurrentRegionUsingFlatTaxSelector)
  const taxLabel = useSelector(state => state.taxes.label)
  const taxClass = classNames(
    'tax',
    'u-float--right',
    'font-5'
  )

  return (
    <Choose>
      <When condition={isCartPath && !isUsingFlatTax}>
        <li>
          {taxLabel}{':'}
          <span className={taxClass}>
            {translate('carts.calculated_in_checkout')}
          </span>
        </li>
      </When>
      <Otherwise>
        <div>
          {
            details.map((taxObject, index) => {
              const { type, rate, amount } = taxObject
              const taxLabel = translate(
                `common.tax_labels.${type.toLowerCase()}`
              )

              return (
                <If condition={taxLabel} key={index} >
                  <TaxListItem
                    currentTax={amount}
                    isCalculated
                    key={index}
                    taxLabel={`${taxLabel} ${rate}%`}
                  />
                </If>
              )
            })
          }
        </div>
      </Otherwise>
    </Choose>
  )
}

export default TaxListItems
